import React from "react";
import IconLink from "./IconLink";
import { MyOffersIcon as MyOffersIconComponent } from "./icons";

export interface MyOffersIconProps {
  className?: string;
  "data-testid"?: string;
  onMyOffersClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
}

const MyOffersIcon: React.FC<MyOffersIconProps> = ({
  className,
  "data-testid": dataTestId,
  onMyOffersClick,
}) => {
  return (
    <IconLink
      href="/myoffers.page"
      icon={<MyOffersIconComponent />}
      label="My Offers"
      onClick={onMyOffersClick}
      data-testid={dataTestId || "header-my-offers-icon"}
      ariaLabel="My Offers"
      className={`${className || ""} my-offers`}
    />
  );
};

export default React.memo(MyOffersIcon);
